import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: "alphabetize"
})
export class AlphabetizePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(array: any, field?: string, isTranslationKey: boolean = false): any[] {
    if (!array || array.length <= 1) {
      return array;
    }

    const newArray = array?.slice();

    newArray?.sort((a: any, b: any) => {
      let aValue = '';
      let bValue = '';

      if (field) {
        if (isTranslationKey) {
          const aKey = a[field]?.toString() || '';
          const bKey = b[field]?.toString() || '';
          aValue = this.translate.instant(aKey).toLowerCase();
          bValue = this.translate.instant(bKey).toLowerCase();
        } else {
          aValue = (a[field]?.toString().toLowerCase() || '');
          bValue = (b[field]?.toString().toLowerCase() || '');
        }
      } else {
        aValue = (a?.toString().toLowerCase() || '');
        bValue = (b?.toString().toLowerCase() || '');
      }
      
      return aValue.localeCompare(bValue, undefined, { sensitivity: 'base' });
    });

    return newArray;
  }
}